<div class="container-fluid px-0 onMove headerSection">
  <ng-container *ngIf="sectionList['headerSection']['visible']">
    <app-header [headerData]="headerData"></app-header>
    <app-stat [statData]="statArr"></app-stat>
  </ng-container>
</div>
  <!-- <mg-container *ngIf="displaySurvey">
    <ws-survey-form [configData]="configDetails" [surveyPopup]="configDetails?.surveyPopUp"></ws-survey-form>
  </mg-container> -->
<!-- <div class="container" *ngIf="!isMobile">
<ng-container>
  <div class="lookpro" *ngIf="configDetails?.showLookerProDashboard">
    <iframe title="lookpro" width="100%" height="520" [src]="lookerProDesktopUrl" frameborder="0" style="border:0" sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe>
  </div>
</ng-container>
</div>
<div class="container" *ngIf="isMobile">
<ng-container>
  <div class="lookpro" *ngIf="configDetails?.showLookerProDashboard">
    <iframe title="lookpro" width="100%" height="520" [src]="lookerProMobileUrl" frameborder="0" style="border:0" sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe>
  </div>
</ng-container>
</div> -->
<div class="md:mx-[84px] px-2 flex flex-col align-center justify-center">
    <div class="w-full" *ngIf="publicHomeDisplayImage?.imageUrl">
    <div class="public-home-display-image w-full relative overflow-hidden">
      <div
        class="absolute top-0 left-0 w-full h-full"
        [innerHTML]="svgContent">
      </div>
    </div>
  </div>
  <ng-container>
    <app-nav-slider [navSlideData]="featuredCourses" [courseListLoad]="courseListLoaded"></app-nav-slider>
  </ng-container>

  <ng-container>
    <app-nav-slider [navSlideData]="caseStudies" [courseListLoad]="caseStudiesLoaded"></app-nav-slider>
  </ng-container>
</div>
 
<section class="infocus container-fluid px-0 infocusCardSection flex flex-col align-center justify-center">
  <ng-container *ngIf="infocusCard.length !== 0 && sectionList['infocusCardSection']['visible']">
    <app-infocusslide [slidesList]="infocusCard"></app-infocusslide>
  </ng-container>
</section>
 
<div class="bg-group container-fluid px-0 KarmayogiHubSection">
  <ng-container *ngIf="sectionList['KarmayogiHubSection']['visible']">
    <app-circular-divs></app-circular-divs>
 
    <div class="learner-tutorial whatisCardSection">
      <ng-container *ngIf="sectionList['whatisCardSection']['visible']">
        <app-nav-slider [navSlideData]="whatisCard"></app-nav-slider>
      </ng-container>
    </div>
  </ng-container>
</div>
 
<div class="container-fluid px-0 social-hub-wrapper socialHubSection">
  <ng-container *ngIf="sectionList['socialHubSection']['visible']">
    <app-social-hub></app-social-hub>
  </ng-container>
 
  <div class=" newsroomCoursesSection lg:mx-32 xs:mx-4" id="newsroom">
    <ng-container *ngIf="sectionList['newsroomCoursesSection']['visible']">
      <app-nav-slider [navSlideData]="newsroomCourses"></app-nav-slider>
    </ng-container>
  </div>
</div>
 
<div class="container-fluid px-0 testimonials-wrapper photosGallerySection">
  <ng-container *ngIf="sectionList['photosGallerySection']['visible']">
 
    <app-photogallery [photosGallery]="photosGallery"></app-photogallery>
 
    <div class="testimonialsSection flex flex-col w-full mx-auto">
      <ng-container *ngIf="sectionList['testimonialsSection']['visible']">
        <app-nav-slider class="slider-center-fix" [navSlideData]="testimonials"></app-nav-slider>
      </ng-container>
    </div>
 
  </ng-container>
</div>
 
<div class="container-fluid px-0 topProvidersSection flex flex-col justify-center items-center">
  <ng-container *ngIf="sectionList['topProvidersSection']['visible']">
 
    <app-nav-slider [navSlideData]="topProviders"></app-nav-slider>
 
    <div class="wallOfFameSection w-100 w-full mt-6 mb-12">
      <!-- Commnented dashboard -->
      <!-- <ng-container *ngIf="sectionList['wallOfFameSection']['visible']">
        <div class="w-100 w-full flex justify-center mb-6 mt-4">
          <span class="text-center text-black text-2xl" style="font-family: Montserrat; font-weight: 600;">
            Dashboard
          </span>
        </div>
        <div class="w-100 w-full flex justify-center px-2 md:px-[84px]">
          <div class="w-full relative overflow-hidden" style="aspect-ratio: 1299 / 740;">
            <div *ngIf="dashboardLoading" class="loader-container absolute inset-0 flex items-center justify-center bg-gray-50 z-10">
              <div class="loader"></div>
            </div>
            <iframe class="absolute top-0 left-0 w-full" 
              src="https://lookerstudio.google.com/embed/reporting/671b1cb5-32b5-422c-909a-ed0f47891b47/page/S6TlF" 
              frameborder="0" style="border:0; height: calc(100% + 50px);" 
              allowfullscreen 
              loading="lazy"
              (load)="onDashboardLoaded()"
              sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-forms allow-modals allow-top-navigation-by-user-activation allow-downloads">
            </iframe>
          </div>
        </div>
      </ng-container> -->
    </div>
 
  </ng-container>
</div>
 
<div class="container-fluid organisationsPartnersSection">
  <ng-container *ngIf="sectionList['organisationsPartnersSection']['visible']">
    <app-nav-slider [navSlideData]="organizationPartners"></app-nav-slider>
  </ng-container>
</div>
 
<div class="aboutUsSection">
  <ng-container *ngIf="sectionList['aboutUsSection']['visible']">
   
  </ng-container>
</div>
 
<div class="container-fluid px-0 contact-us-wrapper videoConfSection">
  <!-- <ng-container *ngIf="sectionList['videoConfSection']['visible']">
    <app-videoconference [videoConf]="videoConf"></app-videoconference>
  </ng-container> -->
</div>
 
<div class="mobileAppDownloadDetailsSection">
  <ng-container *ngIf="sectionList['mobileAppDownloadDetailsSection']['visible']">
    <app-mobileapp-download [mobileAppDownloadDetails]="mobileAppDownloadDetails"></app-mobileapp-download>
  </ng-container>
</div>
 
<div class="mobileviewAppDownloadDetailsSection">
  <ng-container *ngIf="sectionList['mobileviewAppDownloadDetailsSection']['visible']">
    <app-app-download [mobileviewAppDownloadDetails]="mobileviewAppDownloadDetails"></app-app-download>
  </ng-container>
</div>
 
<div class="container-fluid footerProviderSection" [ngClass]="{'mb-2': !sectionList['footerProviderSection']['visible']}">
  <ng-container *ngIf="sectionList['footerProviderSection']['visible']">
    <app-footer-provider [navFooterDetails]="navFooterDetails" [footerProvider]="footerProvider"></app-footer-provider>
  </ng-container>
</div>
